import { useSyncExternalStore } from 'react';

import { getLastActivityLabel, useLanguage } from 'src/helpers';

const refreshIntervalMs = 30000;
const refreshSubscribers = new Set();

let refreshIntervalId = null;
let refreshVersion = 0;

const getRefreshSnapshot = () => refreshVersion;
const subscribeNoop = () => () => {};

const notifyRefreshSubscribers = () => {
  refreshVersion += 1;
  refreshSubscribers.forEach((callback) => callback());
};

const subscribeLastActivityRefresh = (callback) => {
  refreshSubscribers.add(callback);

  if (!refreshIntervalId) {
    refreshIntervalId = setInterval(notifyRefreshSubscribers, refreshIntervalMs);
  }

  return () => {
    refreshSubscribers.delete(callback);

    if (!refreshSubscribers.size && refreshIntervalId) {
      clearInterval(refreshIntervalId);
      refreshIntervalId = null;
    }
  };
};

const useLastActivityRefresh = (active) => {
  useSyncExternalStore(
    active ? subscribeLastActivityRefresh : subscribeNoop,
    getRefreshSnapshot,
    getRefreshSnapshot
  );
};

export const ActivityLabel = ({ accountState, lastActivity }) => {
  useLanguage();
  useLastActivityRefresh(!!lastActivity);

  return getLastActivityLabel({ accountState, lastActivity });
};
